// Import ES6 Promise
import 'es6-promise/auto'

// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'
// import VueSweetAlert2 from 'vue-sweetalert2'

import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'

// Import Helpers for filters
import { domain, count, prettyDate, pluralize } from './filters'

// Import mixins
import './mixins/dateTimeMixin'

// Import Views - Top level
import AppView from './components/App.vue'
// import LoginView from './components/Login.vue'

import config from './config'
import utilities from './utilities'

import ClientHub from './signalr/clienthub'
Vue.use(ClientHub)

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)

Vue.use(VueRouter)

// Routing logic
// https://router.vuejs.org/guide/advanced/meta.html
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if ((!router.app.$store.state.token || router.app.$store.state.token === 'null') ||
        ((router.app.$store.state.tokenValidAt || router.app.$store.state.tokenValidAt !== 'null') &&
          router.app.$store.state.tokenValidAt < new Date().getTime())) {
      window.console.log('Not authenticated')
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      if (utilities.IsMenuAuthorized(to.name)) {
        var tokenValidAt = new Date().setMinutes(new Date().getMinutes() + config.sessionTimeout)
        router.app.$store.tokenValidAt = tokenValidAt
        if (window.localStorage) {
          window.localStorage.setItem('tokenValidAt', tokenValidAt)
        }
        next()
      }
    }
  } else {
    next()
  }
})

sync(store, router)

// Check local storage to handle refreshes
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
    store.commit('SET_TOKEN_VALID_AT', window.localStorage.getItem('tokenValidAt'))
  }
}

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView)
})

// change this. demo
// window.bugsnagClient = window.bugsnag('02fe1c2caaf5874c50b6ee19534f5932')
// window.bugsnagClient.use(window.bugsnag__vue(Vue))

// router.beforeEach((to, from, next) => {
//   if (
//     to.matched.some(record => record.meta.requiresAuth) &&
//     (
//       (!router.app.$store.state.token || router.app.$store.state.token === 'null') ||
//       ((router.app.$store.state.tokenValidAt || router.app.$store.state.tokenValidAt !== 'null') &&
//         router.app.$store.state.tokenValidAt < new Date().getTime())
//     )
//   ) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     if (router.app.$store.state.tokenValidAt < new Date().getTime()) {
//       window.console.log('Not authenticated')
//       next({
//         path: '/login',
//         query: { redirect: to.fullPath }
//       })
//     }
//   } else {
//     var tokenValidAt = new Date().setMinutes(new Date().getMinutes() + config.sessionTimeout)
//     router.app.$store.tokenValidAt = tokenValidAt
//     if (window.localStorage) {
//       window.localStorage.setItem('tokenValidAt', tokenValidAt)
//     }
//     next()
//   }
// })



// WEBPACK FOOTER //
// ./src/main.js